// Service for interacting with the RAG Pipeline API

const RAG_API_BASE_URL = process.env.REACT_APP_RAG_API_URL || 'https://agentassist-rag-api-heahfkbnhcehbffd.eastus-01.azurewebsites.net';

/**
 * Search for resolution steps using the RAG pipeline
 * @param {string} query - The incident description or query
 * @returns {Promise<Object>} - Response containing resolution steps and similar tickets
 */
export const searchResolutionSteps = async (query) => {
  try {
    const response = await fetch(`${RAG_API_BASE_URL}/api/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error(`RAG API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling RAG API:', error);
    throw error;
  }
};

/**
 * Check RAG API health status
 * @returns {Promise<Object>} - Health status information
 */
export const checkRAGHealth = async () => {
  try {
    const response = await fetch(`${RAG_API_BASE_URL}/api/health`);
    
    if (!response.ok) {
      throw new Error(`Health check failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('RAG health check failed:', error);
    throw error;
  }
};
